import { LevelPaths } from "./LevelPaths";
import { QuestBucket } from "./QuestBucket";

export const BucketOfLearnins = ({
  currentPaths = [],
  currentQuests = [],
  hasOutstandingStrictAssignment = false,
}) => {
  if (hasOutstandingStrictAssignment) {
    return null;
  }

  return (
    <>
      <QuestBucket currentQuests={currentQuests} />
      <LevelPaths currentPaths={currentPaths} />
    </>
  );
};
